import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_FindingView } from '../../../../../_entity/finding-view/ModuleFE_FindingView.js';
import './Renderer_FindingViewHeader.scss';
export class Renderer_FindingViewHeader extends ComponentSync {
    __onFindingViewsUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.findingView?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ findingView: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.findingView?._id)
            state.findingView = ModuleFE_FindingView.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'finding-view-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'finding-view-header__title', children: this.state.findingView?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const findingView = this.state.findingView;
        if (!findingView?.type)
            return;
        return _jsxs("span", { className: 'finding-view-header__sub-title', children: ["Type: ", findingView.type] });
    };
}
//# sourceMappingURL=Renderer_FindingViewHeader.js.map